/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "@shared/apis/fetch-clients/radar-fetch-client";
import type { ListDeliveriesQueryResponse, ListDeliveriesPathParams, ListDeliveriesQueryParams, ListDeliveries400, ListDeliveries403, ListDeliveries404 } from "../../models/subscriptionAuditController/ListDeliveries";
import type { Client, RequestConfig, ResponseErrorConfig } from "@shared/apis/fetch-clients/radar-fetch-client";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const listDeliveriesQueryKey = (id: ListDeliveriesPathParams["id"], params?: ListDeliveriesQueryParams) => [{ url: '/audit/event-subscriptions/:id/deliveries', params: {id:id} }, ...(params ? [params] : [])] as const

export type ListDeliveriesQueryKey = ReturnType<typeof listDeliveriesQueryKey>

/**
 * @description Admin-only auditing view. Full delivery payloads are never returned — only outcomes plus a safe `eventSummary` (contact name and life-event type).
 * @summary List a subscription’s delivery history
 * {@link /audit/event-subscriptions/:id/deliveries}
 */
export async function listDeliveries(id: ListDeliveriesPathParams["id"], params?: ListDeliveriesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {
  const { client: request = fetch, ...requestConfig } = config



  const res = await request<ListDeliveriesQueryResponse, ResponseErrorConfig<ListDeliveries400 | ListDeliveries403 | ListDeliveries404>, unknown>({ method : "GET", url : `/audit/event-subscriptions/${id}/deliveries`, params, ... requestConfig })
  return res.data
}

export function listDeliveriesQueryOptions(id: ListDeliveriesPathParams["id"], params?: ListDeliveriesQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = listDeliveriesQueryKey(id, params)
        return queryOptions<ListDeliveriesQueryResponse, ResponseErrorConfig<ListDeliveries400 | ListDeliveries403 | ListDeliveries404>, ListDeliveriesQueryResponse, typeof queryKey>({
         enabled: !!(id),
         queryKey,
         queryFn: async ({ signal }) => {
            return listDeliveries(id, params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @description Admin-only auditing view. Full delivery payloads are never returned — only outcomes plus a safe `eventSummary` (contact name and life-event type).
 * @summary List a subscription’s delivery history
 * {@link /audit/event-subscriptions/:id/deliveries}
 */
export function useListDeliveries<TData = ListDeliveriesQueryResponse, TQueryData = ListDeliveriesQueryResponse, TQueryKey extends QueryKey = ListDeliveriesQueryKey>(id: ListDeliveriesPathParams["id"], params?: ListDeliveriesQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<ListDeliveriesQueryResponse, ResponseErrorConfig<ListDeliveries400 | ListDeliveries403 | ListDeliveries404>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...resolvedOptions } = queryConfig
         const queryKey = resolvedOptions?.queryKey ?? listDeliveriesQueryKey(id, params)
         

         const query = useQuery({
          ...listDeliveriesQueryOptions(id, params, config),
          ...resolvedOptions,
          queryKey,
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ListDeliveries400 | ListDeliveries403 | ListDeliveries404>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}